import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ResourceType } from "../../interfaces/general";

interface PathSliceStateInterface {
    currentResource: ResourceType | null;
}

const pathSliceState: PathSliceStateInterface = {
    currentResource: null
};

export const pathSlice = createSlice({
    name: "path",
    initialState: pathSliceState,
    reducers: {
        setCurrentResource: (state, action: PayloadAction<ResourceType | null>) => {
            state.currentResource = action.payload;
        }
    }
});

export const { setCurrentResource } = pathSlice.actions;
export const selectPath = (state: RootState) => state.path;
export default pathSlice.reducer;
